import {validate as validator} from "validate.js";

const rules = () => {
    return {
        name: {
            presence: true,
            length: {
                minimum: 2,
            }
        },
        email: {
            presence: true,
            email: true
        },
        phone: {
            presence: true,
            length: {
                minimum: 7,
            }
        },
    }
};

const validate = (buyerParent) => {
    return validator(buyerParent, rules())
};

export default {validate};
